import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';

import { NeonRewards } from '#src/components/rewards/NeonRewards/index.tsx';

import type { FixtureNeonRewards_so5Fixture } from './__generated__/index.graphql.ts';

type Props = {
  so5Fixture: FixtureNeonRewards_so5Fixture;
} & Pick<ComponentProps<typeof NeonRewards>, 'size' | 'iconSize' | 'className'>;

export const FixtureNeonRewards = ({
  so5Fixture,
  size = 24,
  iconSize = 2,
  className,
}: Props) => {
  return (
    <NeonRewards
      className={className}
      size={size}
      iconSize={iconSize}
      displayLabels={false}
      verificationNeeded={{
        phoneNumber: so5Fixture.myUnclaimedSo5RewardsNeedPhoneVerification,
        kyc: so5Fixture.myUnclaimedSo5RewardsNeedKycVerification,
      }}
      anyRewardConfigInterfaces={so5Fixture.myBoostedEligibleRewardConfigs}
      myCompletedThresholdsStreakTasksCount={
        so5Fixture.myCompletedThresholdsStreakTasksCount
      }
      myCommonCompletedThresholdsStreakTasksCount={
        so5Fixture.myCommonCompletedThresholdsStreakTasksCount
      }
    />
  );
};

FixtureNeonRewards.fragments = {
  so5Fixture: gql`
    fragment FixtureNeonRewards_so5Fixture on So5Fixture {
      slug
      myUnclaimedSo5RewardsNeedPhoneVerification
      myUnclaimedSo5RewardsNeedKycVerification
      myCompletedThresholdsStreakTasksCount(
        rarities: [limited, rare, super_rare, unique]
      )
      myCommonCompletedThresholdsStreakTasksCount: myCompletedThresholdsStreakTasksCount(
        rarities: [common]
      )
      myBoostedEligibleRewardConfigs: myEligibleRewardConfigs(
        multiplyBaseRewards: true
        includeThresholdsStreakTasks: true
      ) {
        id
        ...NeonRewards_anyRewardConfigInterface
      }
    }
    ${NeonRewards.fragments.anyRewardConfigInterface}
  ` as TypedDocumentNode<FixtureNeonRewards_so5Fixture>,
};
